import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (window.__deferredInstallPrompt) setDeferred(window.__deferredInstallPrompt);
    const onAvail = () => setDeferred(window.__deferredInstallPrompt);
    const onInstalled = () => {
      window.__deferredInstallPrompt = null;
      setInstalled(true);
    };
    window.addEventListener('pwa-install-available', onAvail);
    window.addEventListener('pwa-installed', onInstalled);
    return () => {
      window.removeEventListener('pwa-install-available', onAvail);
      window.removeEventListener('pwa-installed', onInstalled);
    };
  }, []);

  const triggerInstall = async (evt) => {
    const target = evt || deferred || window.__deferredInstallPrompt;
    if (!target) {
      toast.info('Use your browser menu › "Install app" to add INDIVALIFE to your home screen');
      return;
    }
    target.prompt();
    const choice = await target.userChoice;
    if (choice.outcome === 'accepted') toast.success('INDIVALIFE installed!');
    window.__deferredInstallPrompt = null;
    setDeferred(null);
  };

  if (installed) return null;

  return (
    <Button
      onClick={() => triggerInstall(null)}
      variant="outline"
      size="sm"
      data-testid="install-pwa-button"
      className="gap-2 border-[#1D4ED8]/40 text-[#1E3A8A] hover:bg-[#EAF1FF]"
    >
      <Download className="h-4 w-4" />
      Install App
    </Button>
  );
};

export default InstallPWA;
